import React from "react";
import {BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import configureAxios from "./store/utils/configureAxios";

import { isLoggedIn, setViewMode } from "./store/actions/authActions";
import {connect} from "react-redux";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardScreen from "./modules/dashboard/dashboard_screen";
import LoginPage from "./modules/auth/view/login";
import ForgotPassword from "./modules/auth/view/forgotPassword";
import ResetPassword from "./modules/auth/view/resetPassword";
import CardConnection from "./modules/connection/connection";
import CardLead from "./modules/lead/lead";
import CardSubscription from "./modules/subscription/subscription";
import CardUpdate from "./modules/card/card-update/cardUpdate";
import CardSettings from "./modules/card/card-settings/cardSettings";
import Widgets from "./modules/card/widgets/widgets";
import Business from "./modules/business/business";
import ActiveSubscription from "./modules/subscription/activeSubscription";
import BusinessUpdate from "./modules/business/updates/updateBusiness";
import BusinessWidgets from "./modules/business/updates/widgetSettings";
import CardGallery from "./modules/gallery/gallery";
import SingleBusiness from "./modules/business/single/singleBusiness";
import CreateNewLead from "./modules/lead/createLead/newLead";
import CardList from "./modules/card/card-list/cardList";
import ProfileSettings from "./modules/user/settings/userInfo";
import PasswordUpdate from "./modules/user/settings/passwordUpdate";
import UserSettings from "./modules/user/settings/settings";
import CardMockup from "./modules/card/mockup/mockup";
import CreateMockup from "./modules/card/mockup/create-mocup/newMockup";
import ScrollToTop from "./components/scroll-top/scrollToTop";
import CreateCard from "./modules/card/card-create/createCard";
import Notification from "./modules/notification/notifications";
import CardTheme from "./modules/card/theme/theme";
import AuthCheckingPage from "./modules/auth/view/auth_checking_page";
import CardCategory from "./modules/card/category/cardCategory";
import ConnectionCategory from "./modules/connection/category/connectionCategory";
import LeadCategory from "./modules/lead/category/leadCategory";
import GalleryCategory from "./modules/gallery/category/galleryCategory";
import CardSingleCategory from "./modules/card/category/single/cardSingleCategory";
import ConnectionSingleCategory from "./modules/connection/category/single/connectionSingleCategory";
import LeadSingleCategory from "./modules/lead/category/single/leadSingleCategory";
import GallerySingleCategory from "./modules/gallery/category/single/gallerySingleCategory";
import UserSummery from "./modules/user/settings/manage";
import UpdateLeadData from "./modules/lead/update/updateLead";
import Login from "./modules/auth/view/login";
import SingleLead from "./modules/lead/single/singleLead";
import SingleCard from "./modules/card/single/singleCard";
import SingleNotification from "./modules/notification/single/singleNotification";
import UserBillingInfo from "./modules/user/store/billings/billing";
import UserMyPlan from "./modules/user/store/myPlan/myPlan";
import UserStore from "./modules/user/store/store/services/service";
import Subscription from "./modules/user/store/store/subscriptions/subscriptions";
class MyRoutes extends React.Component {
	state = {
		user: "",
		viewMode: null,
		error: {},
	};
	async componentWillMount() {
		configureAxios(); // Run Basic Axios Configure
	}

	componentDidMount() {
		// Extract token from URL
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("token");

		if (token) {
			// Store token in localStorage
			localStorage.setItem("authToken", token);

			// Remove token from URL
			const newUrl = window.location.origin + window.location.pathname;
			window.history.replaceState({}, document.title, newUrl);

			// Reload the page
			window.location.reload();
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (
			JSON.stringify(prevProps.auth) !== JSON.stringify(this.props.auth)
		) {
			let viewMode = "business";
			this.props.setViewMode(viewMode);
		}
	}

	render() {
		let { isAuthenticated, authChecked } = this.props.auth;
		return (
			<BrowserRouter>
			  	<ScrollToTop />
					{(() => {
						if(!authChecked){
							return (
								<Routes>
									<Route path="/" element={<AuthCheckingPage />} />
									<Route path="/*" element={<AuthCheckingPage />} />
								</Routes>
							);
						}else if(isAuthenticated){
							return(
				  				<Routes>
									{/* Public Routes */}
									<Route path="/" element={<DashboardScreen />} />

									{/* Group User Routes */}
									<Route path="/user">
										<Route index element={<Navigate to="/user/manage" replace />} />
										<Route path="manage" element={<UserSummery />} />
										<Route path="profile" element={<ProfileSettings />} />
										<Route path="password" element={<PasswordUpdate />} />
										<Route path="settings" element={<UserSettings />} />
										<Route path="billings" element={<UserBillingInfo />} />
										<Route path="plans" element={<UserMyPlan />} />
										<Route path="store" element={<Navigate to="/user/store/subscriptions" replace />} />
										<Route path="store/subscriptions" element={<Subscription />} />
										<Route path="store/services" element={<UserStore />} />
									</Route>

									{/* Group Single Routes */}
									<Route path="/notification">
										<Route index element={<Notification />} />
										<Route path="unread" element={<Notification />} />
										<Route path="archived" element={<Notification />} />
										<Route path=":id" element={<SingleNotification />} />
									</Route>
									{/* Group Lead Routes */}
									<Route path="/lead">
										<Route index element={<CardLead />} />
										<Route path="category" element={<LeadCategory />} />
										<Route path="category/:id" element={<LeadSingleCategory />} />
										<Route path="update" element={<Navigate to="/lead" />} />
										<Route path="update/:id" element={<UpdateLeadData />} />
										<Route path="single" element={<Navigate to="/lead" />} />
										<Route path="single/:id" element={<SingleLead />} />
										<Route path="new" element={<CreateNewLead />} />
									</Route>

									{/* Group Connection Routes */}
									<Route path="/connection">
										<Route index element={<CardConnection />} />
										<Route path="category" element={<ConnectionCategory />} />
										<Route path="category/:id" element={<ConnectionSingleCategory />} />
									</Route>

									{/* Group Card Routes */}
									<Route path="/card">
										<Route index element={<CardList />} />
										<Route path="update" element={<CardUpdate />} />
										<Route path="settings" element={<Navigate to="/card" />} />
										<Route path="settings/:id" element={<CardSettings />} />
										<Route path="new" element={<CreateCard />} />
										<Route path="theme" element={<CardTheme />} />
										<Route path="category" element={<CardCategory />} />
										<Route path="category/:id" element={<CardSingleCategory />} />
										<Route path=":id" element={<SingleCard />} />
									</Route>

									{/* Group Business Routes */}
									<Route path="/business">
										<Route index element={<Business />} />
										<Route path="update/:id" element={<BusinessUpdate />} />
										<Route path="update" element={<Navigate to="/business" />} />
										<Route path="widgets" element={<BusinessWidgets />} />
										<Route path=":id" element={<SingleBusiness />} />
										<Route path="single/mockup" element={<CardMockup />} />
										<Route path="single/mockup/new" element={<CreateMockup />} />
									</Route>

									{/* Group Subscription Routes */}
									<Route path="/subscription">
										<Route index element={<ActiveSubscription />} />
										<Route path="packages" element={<CardSubscription />} />
									</Route>
									{/* Group Gallery Routes */}
									<Route path="/gallery">
										<Route index element={<CardGallery />} />
										<Route path="category" element={<GalleryCategory />} />
										<Route path="category/:id" element={<GallerySingleCategory />} />
									</Route>

									{/* Other Routes */}
									<Route path="/widgets" element={<Widgets />} />
								</Routes>
							);
						}else{
							return (
								<Routes>
									<Route path="/" element={<AuthCheckingPage />} />
									<Route path="/login" element={<Login />} />
									<Route path="/forgot-password" element={<ForgotPassword />} />
									<Route path="/reset-password" element={<ResetPassword />} />
									<Route path="/*" element={<AuthCheckingPage />} />
								</Routes>
							);
						}
					})()}

				<ToastContainer
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					pauseOnFocusLoss={false}
					draggable
					pauseOnHover
				/>
				<ToastContainer />
			</BrowserRouter>
		);
	}
}

// export default App;


const mapStateToProps = (state) => ({
	auth: state.auth,
});
const mapDispatchToProps = {
	isLoggedIn: isLoggedIn,
	setViewMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyRoutes);
